'use strict';

export default class UrlWindow {
    constructor(paginator) {
        this.paginator = paginator;
    }

    get(onEachSide) {
        if (this.paginator.lastPage() < onEachSide * 2 + 6) {
            return this.getSmallSlider();
        }

        return this.getUrlSlider(onEachSide);
    }

    getSmallSlider() {
        return {
            first: this.paginator.getUrlRange(1, this.lastPage()),
            slider: null,
            last: null,
        };
    }

    getUrlSlider(onEachSide) {
        const window = onEachSide * 2;

        if (!this.hasPages()) {
            return {first: null, slider: null, last: null};
        }

        // If the current page is very close to the beginning of the page range, we will
        // just render the beginning of the page range, followed by the last 2 of the
        // links in this list, since we will not have room to create a full slider.
        if (this.currentPage() <= window) {
            return this.getSliderTooCloseToBeginning(window);
        }

        // If the current page is close to the ending of the page range we will just get
        // this first couple pages, followed by a larger window of these ending pages
        // since we're too close to the end of the list to create a full on slider.
        else if (this.currentPage() > this.lastPage() - window) {
            return this.getSliderTooCloseToEnding(window);
        }

        // If we have enough room on both sides of the current page to build a slider we
        // will surround it with both the beginning and ending caps, with this window
        // of pages in the middle providing a Google style sliding paginator setup.
        return this.getFullSlider(onEachSide);
    }

    getSliderTooCloseToBeginning(window) {
        return {
            first: this.paginator.getUrlRange(1, window + 2),
            slider: null,
            last: this.getFinish(),
        };
    }

    getSliderTooCloseToEnding(window) {
        const last = this.paginator.getUrlRange(this.lastPage() - (window + 2), this.lastPage());

        return {
            first: this.getStart(),
            slider: null,
            last,
        };
    }

    getFullSlider(onEachSide) {
        return {
            first: this.getStart(),
            slider: this.getAdjacentUrlRange(onEachSide),
            last: this.getFinish(),
        };
    }

    getAdjacentUrlRange(onEachSide) {
        return this.paginator.getUrlRange(this.currentPage() - onEachSide, this.currentPage() + onEachSide);
    }

    getStart() {
        return this.paginator.getUrlRange(1, 2);
    }

    getFinish() {
        return this.paginator.getUrlRange(this.lastPage() - 1, this.lastPage());
    }

    hasPages() {
        return this.paginator.lastPage() > 1;
    }

    currentPage() {
        return this.paginator.currentPage();
    }

    lastPage() {
        return this.paginator.lastPage();
    }
}
